import z from 'zod';

const customErrorMap: z.ZodErrorMap = (issue, ctx) => {
  if (issue.message)
    return { message: issue.message };

  if (issue.code === z.ZodIssueCode.too_small) {
    if (issue.type === 'string' && issue.minimum === 1) {
      return { message: "Field cannot be empty" };
    }
  }
  return { message: ctx.defaultError };
};

z.setErrorMap(customErrorMap);

export const disclaimerErrorMap: z.ZodErrorMap = (issue, ctx) => {
  if (issue.code === z.ZodIssueCode.invalid_literal) {
    if (issue.expected === true) {
      return { message: "You must agree to the disclaimer" };
    }
  }
  return { message: ctx.defaultError };
};